import { IAttachment } from "interfaces/Attachments";
import { useState } from "react";
import GalleryPictureModal from "./GalleryPictureModal";

import * as S from "./styles";

type AttachmentsGalleryProps = {
  photoGallery: IAttachment[];
  pictureWidth?: `${number}px` | `${number}rem`;
  pictureHeight?: `${number}px` | `${number}rem`;
  galleryContainerHeight?: string;
  galleryContainerGridTemplateColumns?: string;
};

export default function AttachmentsGallery({
  photoGallery,
  galleryContainerGridTemplateColumns,
  pictureWidth,
  galleryContainerHeight,
  pictureHeight
}: AttachmentsGalleryProps) {
  const [isPictureModalOpen, setIsPictureModalOpen] = useState<boolean>(false);
  const [selectedPictureIndex, setSelectedPictureIndex] = useState<number>(0);

  if (!photoGallery[selectedPictureIndex]) return null;

  return (
    <S.PhotoGalleryContainer>
      <S.ImageGalleryContainer galleryGridTemplateColumns={galleryContainerGridTemplateColumns} galleryContainerHeight={galleryContainerHeight}>
        {photoGallery?.map((picture, index) => (
          <S.GalleryPicture
            pictureHeight={pictureHeight}
            pictureWidth={pictureWidth}
            src={picture?.url}
            alt={picture?.caption}
            onClick={() => {
              setSelectedPictureIndex(index);
              setIsPictureModalOpen(true);
            }}
          />
        ))}
      </S.ImageGalleryContainer>

      {selectedPictureIndex !== undefined && (
        <GalleryPictureModal
          imgUrl={photoGallery[selectedPictureIndex]?.url}
          imgAlt={photoGallery[selectedPictureIndex]?.caption ?? "Modal image"}
          galleryLength={photoGallery?.length}
          selectedGalleryPictureIndex={selectedPictureIndex}
          onLeftArrowClick={() => setSelectedPictureIndex((prev) => prev - 1)}
          onRightArrowClick={() => setSelectedPictureIndex((prev) => prev + 1)}
          coord={photoGallery[selectedPictureIndex]?.coord}
          isOpen={isPictureModalOpen}
          onCloseButtonClick={() => {
            setIsPictureModalOpen(false);
          }}
        />
      )}
    </S.PhotoGalleryContainer>
  );
}
